import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Popup2 } from 'libs/ui';
import { Title } from 'libs/form';
import { updatePermission } from 'services/role-service';
import { StyledButtonContainer, StyledInput, Content, Permissions } from './permissions-form.styled';

export const PermissionsForm = (props) => {
  const { t } = useTranslation();
  const { close, initialValues, id } = props;

  const [permissions, setPermissions] = useState(initialValues.permissions);
  const [flt, setFlt] = useState('');

  /**
   * change permission
   * @param {*} e
   * @param {*} name
   */
  const changePermission = (e, name) => {
    const val = e.target.checked;
    updatePermission(id, name, val).then(() => {
      const out = [...permissions];
      const idxOk = out.findIndex((el) => el.permission_id === name);
      out[idxOk].is_allowed = val;
      setPermissions(out);
    });
  };

  const filter = (e) => {
    setFlt(e.target.value);
  };

  const cancel = () => {
    close();
  };

  const filteredPermissions = permissions.filter((el) => el.permission_description.toLowerCase().includes(flt.toLowerCase()));

  return (
    <Popup2 w={580} top={10}>
      <Title>{t('form.Разрешения для роли ') + initialValues.name}</Title>
      <form>
        <Content>
          <Permissions>
            {filteredPermissions.map((el, idx) => (
              <label key={idx}>
                <input onChange={(e) => changePermission(e, el.permission_id)} type="checkbox" name={el.permission_id} checked={el.is_allowed} />
                <span>{el.permission_description}</span>
              </label>
            ))}
          </Permissions>
        </Content>
        <StyledButtonContainer space="20px">
          <StyledInput value={flt} onChange={filter} type="text" label={t('grid.Фильтр')} placeholder={t('grid.Фильтр')} name="flt" />
          <Button type="button" onClick={cancel}>
            {t('buttons.Закрыть')}
          </Button>
        </StyledButtonContainer>
      </form>
    </Popup2>
  );
};
